export const TEXT = {
    MEMBERS: 'members',
    MEDIA: 'media',
    IMAGE: 'image',
    IMAGES: 'images',
    VIDEO: 'video',
    VIDEOS: 'videos',
    VIEW_GROUP: 'view group'
};